import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var appSettings = require("./../../../appsettings.json");

export var AppConfig = function () {
  function AppConfig() {
    _classCallCheck(this, AppConfig);
  }

  _createClass(AppConfig, null, [{
    key: "SignalServerEndPoint",
    get: function get() {
      return window['SignalServerEndPoint'] || appSettings.SignalServerUrl;
    }
  }, {
    key: "SignalServerPingUrl",
    get: function get() {
      return this.SignalServerEndPoint + "/ping";
    }
  }, {
    key: "TurnServerConfiguration",
    get: function get() {
      return appSettings.TurnServerConfiguration;
    }
  }, {
    key: "TurnServerStagingConfiguration",
    get: function get() {
      return appSettings.TurnServerStagingConfiguration;
    }
  }]);

  return AppConfig;
}();